define('glu/grid/tableLayout',['require','../browser','../layout','../$','../$window','./adoptRegion','hbs!./tableLayout.hbs','./body/emptyView','../util'],function(require) {
    'use strict';

    var browser = require('../browser'),
        Layout = require('../layout'),
        $ = require('../$'),
        $window = require('../$window'),
        AdoptRegion = require('./adoptRegion'),
        tpl = require('hbs!./tableLayout.hbs'),
        EmptyView = require('./body/emptyView'),
        util = require('../util');

    return Layout.extend({
        template: tpl,
        className: 'table-layout',

        regions: {
            caption: 'caption',
            header: 'thead',
            body: {
                'selector': 'tbody',
                regionType: AdoptRegion
            },
            footer: 'tfoot',
            info: '[data-hook="infoContainer"]'
        },

        events: {
            'mouseover td[data-title]': 'addTitle',
            'mouseout td[data-generated-title]': 'removeTitle'
        },

        appEvents: {
            'resize': 'setWidth'
        },

        addTitle: function(e) {
            var $el = this.$(e.currentTarget);
            // if title is empty or undefined
            if (!$el.attr('title')) {
                $el.attr({
                    'title': util.unescape($el.data('title')), // 'title' is a safe attribute for untrusted data
                    'data-generated-title': 'true'
                });
            }
        },

        removeTitle: function(e) {
            var $el = this.$(e.currentTarget);

            $el.removeAttr('title');
            $el.removeAttr('data-generated-title');
        },

        initialize: function() {
            Layout.prototype.initialize.apply(this, arguments);

            this.defaultWidth = this.options.defaultWidth || 100;
            this.grid = this.options.grid;
            this.masterCollection = this.options.masterCollection;
            this.loading = false;

            // Determine whether to load with an immediate loading state based on
            // collection's `requestingAttributes` flag
            if (this.options.serverSidePagination) {
                this.loading = this.masterCollection.requestingAttributes;
            }

            // TODO `desync` event is deprecated, all logic now hangs off of the Backbone event `request`
            this.listenTo(this.masterCollection, {
                'desync request': this.showLoadingView,
                'sync remove': this.hideInfoView
            });

            this.listenTo(this.grid, {
                'grid:contentRendered': this.setWidth
            });

            this.listenTo(this.grid.columns, {
                'change:width': this.setWidth,
                'change:condition add remove': function() {
                    if (browser.msie) {
                        this.render();
                    }
                }
            });
        },

        setCaption: function(caption) {
            this.captionView = caption;
        },

        setHeader: function(header) {
            this.headerView = header;
        },

        setBody: function(body) {
            this.bodyView = body;
        },

        onRender: function() {
            if (this.captionView) {
                this.caption.show(this.captionView);
            } else {
                this.removeRegion('caption');
            }
            if (this.headerView) {
                this.header.show(this.headerView);
                this.listenTo(this.headerView.collection, 'sync', this.setWidth);
            }
            if (this.bodyView) {
                this.body.show(this.bodyView);
                this.listenTo(this.bodyView.collection, 'add reset remove', this.toggleEmptyView);
            }

            if (this.loading) {
                this.showLoadingView();
            }

            this.toggleEmptyView();
        },

        setWidth: function() {
            var self = this,
                $table = self.$('table'),
                $canvas = self.$('.js-canvas'),
                $footer = self.grid.$('.footer'),
                viewportWidth = self.$el.width(),
                tableWidth = $table.outerWidth(),
                calculatedWidth = 0;

            $canvas.width(viewportWidth);
            $table.width(viewportWidth);
            $footer.width(viewportWidth);

            // Grids with disableDynamicColumnWidths enabled do not use this function for table column widths, they use CSS only to manage widths
            // But sticky footers need to have their width set regardless of this setting
            if (this.options.disableDynamicColumnWidths || this.isClosed) {
                //trigger event to update footer position
                this.grid.trigger('grid:columnWidthUpdated');
                return false;
            }

            $table.find('thead th').each(function(i, el) {
                calculatedWidth += self.getColumnWidth(self.$(el));
            });

            if (tableWidth > calculatedWidth) {
                tableWidth = calculatedWidth;
            }

            $table.width(tableWidth < viewportWidth ? viewportWidth : tableWidth);
            $table.find('thead th').each(function(i, el) {
                self.setColumnWidth(self.$(el));
            });

            //trigger event to update footer position
            this.grid.trigger('grid:columnWidthUpdated');

            //if grid is inside a dashboard region
            if (this.$el.closest('.dashboard-region').length) {
                //reset the inline width (GLU-1096)
                $footer.css('width', 'auto');
            }
        },

        getColumnWidth: function($th) {
            var cellData = $th.data(),
                initialWidth = cellData.initialWidth,
                isInitialAuto = (initialWidth === 'auto');

            initialWidth = isInitialAuto ? $th.outerWidth() : initialWidth;

            // re-set 'auto' width for columns in case if scroll appears
            if (cellData.gridColumnWidth === 'default') {
                $th.css({
                    width: 'auto',
                    minWidth: 'auto'
                });

                initialWidth = $th.outerWidth() > 0 ? $th.outerWidth() : this.defaultWidth;
            }
            return initialWidth;
        },

        setColumnWidth: function($th) {
            var cellData = $th.data(),
                initialWidth = this.getColumnWidth($th),
                headerModel = this.header.currentView.collection.get(cellData.cid);

            initialWidth = initialWidth < this.defaultWidth && cellData.gridColumnWidth === 'default' ? this.defaultWidth : initialWidth;

            $th.css({
                width: initialWidth,
                minWidth: initialWidth,
                maxWidth: initialWidth
            });

            if (!headerModel) {
                return; // some th elements do not have an associated model
            }

            headerModel.set('width', initialWidth, {
                silent: true
            });
        },

        toggleEmptyView: function() {
            if (this.loading) {
                return;
            }
            if (this.bodyView && !this.bodyView.collection.isEmpty()) {
                this.info.reset();
            } else {
                this.info.show(new EmptyView({
                    resultsName: this.grid.options.resultsName,
                    text: this.options.emptyViewText
                }));

                this.grid.trigger('grid:content:empty');
            }
        },

        showLoadingView: function(model, xhr, options) {
            options = options || {};

            if (options.skipLoading) {
                return;
            }

            this.loading = true;

            var LoadingView = this.options.loadingView;
            this.info.show(new LoadingView({
                text: this.options.loadingViewText
            }));
        },

        hideInfoView: function() {
            this.loading = false;

            // this needs for case when master collection is empty in all other cases `this.toggleEmptyView` method
            // will be triggered after setting models to masterCollection
            if (this.masterCollection.isEmpty()) {
                this.toggleEmptyView();
            }
        }
    });
});

